import { createFileRoute } from "@tanstack/react-router";
import TreatmentResistantDepressionPage from "@/pages/learn/TreatmentResistantDepressionPage";
import { page6 } from "@/pages/learn/learnDataP6";
export const Route = createFileRoute(
  "/learn/what-is-treatment-resistant-depression",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: page6.title,
        },
        {
          name: "description",
          content: page6.description,
        },
        {
          property: "og:title",
          content: page6.title,
        },
        {
          property: "og:description",
          content: page6.description,
        },
        {
          property: "og:url",
          content: `https://neurowellnesstms.com${page6.canonical}`,
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: `https://neurowellnesstms.com${page6.canonical}`,
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(page6.schemaJson),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TreatmentResistantDepressionPage />;
}
